require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-k-nearest-neighbors.json") })
        }
      }, "path---posts-k-nearest-neighbors");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-k-nearest-neighbors!./.cache/json/posts-k-nearest-neighbors.json
// module id = 386
// module chunks = 231608221292675